const accessRoute = {
  Resume_Details: {
    path: "/resume-details",
  },
};
export default accessRoute;
